import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = {
    autoremove: {
      type: Number,
      default: 0
    }
  }

  connect () {
    // console.log('toast controller connect')
    if (this.autoremoveValue > 0)
      this.loop_id = setInterval(() => {
        this.close()
      }, this.autoremoveValue)
  }

  disconnect () {
    clearInterval(this.loop_id)
  }

  close () {
    this.element.classList.add('hidden')
    this.element.remove()
  }
}


